import { cn } from '@/lib/utils';
import { ShortlistBookCallButton } from '@/modules/public-shortlist/components/ShortlistBookCallButton';
import {
  SHORTLIST_HEADER_CTA_LABEL,
  FINLAY_MARKETING_URL,
} from '@/modules/public-shortlist/constants';

interface ShortlistHeaderProps {
  onCtaClick: () => void;
  showCta?: boolean;
  contentClassName?: string;
}

export function ShortlistHeader({
  onCtaClick,
  showCta = false,
  contentClassName = 'max-w-3xl',
}: ShortlistHeaderProps) {
  return (
    <header className="sticky top-3 z-40 px-4 pt-3 sm:top-4 sm:px-6 sm:pt-4 lg:px-8">
      <div
        className={cn(
          'border-border mx-auto flex h-14 items-center justify-between rounded-2xl border bg-white/95 px-4 shadow-sm backdrop-blur-sm sm:px-5',
          contentClassName,
        )}
      >
        <a
          href={FINLAY_MARKETING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="focus-visible:ring-primary-600 shrink-0 rounded-md focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
        >
          <img
            src="/logo.png"
            alt="Finlay"
            className="h-8 w-auto object-contain"
          />
        </a>
        <ShortlistBookCallButton
          label={SHORTLIST_HEADER_CTA_LABEL}
          onClick={onCtaClick}
          size="sm"
          className={cn(
            'hidden transition-opacity duration-300 sm:inline-flex',
            showCta ? 'opacity-100' : 'pointer-events-none opacity-0',
          )}
          tabIndex={showCta ? 0 : -1}
          aria-hidden={!showCta}
        />
      </div>
    </header>
  );
}
